// extracted by mini-css-extract-plugin
export default {"tableInfo":"total-table_tableInfo__gKilF","skeleton":"total-table_skeleton__um+YK","shimmer":"total-table_shimmer__P9opz"};